export default __webpack_public_path__ + "static/media/Background_00161.e24bd821.png";